import type { ComponentType, ForwardRefRenderFunction } from 'react'
import { forwardRef, useState } from 'react'

import type { MovingModalProps } from './MovingModal'
import { MovingModal } from './MovingModal'
import type { ModalInterface, ModalInterfaceClose } from './types'

export function usingMovingModal<T extends ModalInterfaceClose>(Component: ComponentType<T>) {
  type ModalComponentProps = Omit<T, 'closeModal'>
  type MovingModalPropsCut = Omit<MovingModalProps, 'anchor'>
  type ResultProps = ModalComponentProps & MovingModalPropsCut

  const Wrapper: ForwardRefRenderFunction<ModalInterface, ResultProps> = (
    { className, isOpen, ...rest },
    refInterface,
  ) => {
    const [anchor, setAnchor] = useState<HTMLDivElement>()

    const closeModal =
      typeof refInterface === 'object' && refInterface?.current != null
        ? refInterface.current.closeModal
        : () => undefined

    return (
      <MovingModal ref={refInterface} className={className} isOpen={isOpen} anchor={anchor}>
        <Component {...(rest as T)} ref={setAnchor} closeModal={closeModal} />
      </MovingModal>
    )
  }

  return forwardRef<ModalInterface, ResultProps>(Wrapper)
}
